import { SessionService } from './impl/session/session.service';
import { Injectable } from '@angular/core';
import { ApplicationStateService } from '../../shared/services/application-state.service';
import { BusinessParamName } from '../../shared/models/request-offer/request-offer.enum';
import { UrlParamsService } from './impl/url-params.service';
import {QueryParamName} from '../enums/query-param-name.enum';

@Injectable({
  providedIn: 'root'
})
export class ProcessService {

  constructor(private sessionService: SessionService,
              private urlParamsService: UrlParamsService,
              private applicationStateService: ApplicationStateService) {
  }

  get processId(): string {
    let processId = this.urlParamsService.getQueryParam(QueryParamName.PROCESS_ID);
    if (!processId) {
      processId = this.applicationStateService.processId;
    }
    return processId;
  }

  get sessionId(): string {
    let sessionId = this.urlParamsService.getQueryParam(QueryParamName.SESSION_ID);
    if (!sessionId) {
      sessionId = this.sessionService.sessionId;
    }
    return sessionId;
  }

  get offerId(): string {
    return this.urlParamsService.getQueryParam(QueryParamName.SESSION_ID);
  }

  get sessionSimpleId(): string {
    let sessionSimpleId = this.applicationStateService.getBusinessParameterValue(BusinessParamName.SESSION_SIMPLE_ID);
    if (!sessionSimpleId) {
      sessionSimpleId = this.sessionService.sessionSimpleId;
    }
    return <string>sessionSimpleId;
  }
}
